import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Header, Popup } from '@calendly/ui/components/popup'
import { RadioInput } from '@calendly/ui/components/radio-input'
import classNames from 'classnames'
import { useState } from 'react'

import radioSelectedDot from './assets/radio-selected.svg'
import {
  optionContentCss,
  optionCopyCss,
  optionCss,
  optionDisabledCss,
  optionSelectedCss,
  optionsCss,
  optInBodyCss,
  optInButtonCss,
  optInDialogContentCss,
  optInEyebrowCss,
  optInFooterCss,
  optInHeaderCopyCss,
  optInOptionDescriptionCss,
  optInOptionLabelCss,
  optInRadioDotCss,
  optInRadioVisualCss,
  optInRadioVisualSelectedCss,
  optInRadioWrapperCss,
  optInTitleCss,
  popupSurfaceCss
} from './styles'
import type { CallieChoice, ExperienceProps } from './types'
import { VariantIcon } from './variant_icon'

export const OptInModal = ({ isLoading, onSave }: ExperienceProps) => {
  const [choice, setChoice] = useState<CallieChoice>('ai')

  return (
    <Popup isBlocking onClose={() => {}} size="max-content">
      <div className={classNames(popupSurfaceCss, optInDialogContentCss)}>
        <Header>
          <div className={optInHeaderCopyCss}>
            <p className={optInEyebrowCss}>
              {I18n.t('publisher.growth_experiments.callie_intro_entry_points.eyebrow')}
            </p>
            <h2 className={optInTitleCss}>
              {I18n.t('publisher.growth_experiments.callie_intro_entry_points.opt_in.title')}
            </h2>
          </div>
        </Header>
        <div className={optInBodyCss}>
          <div
            aria-label={I18n.t('publisher.growth_experiments.callie_intro_entry_points.opt_in.title')}
            className={optionsCss}
            role="radiogroup"
          >
            <label
              className={classNames(optionCss, {
                [optionSelectedCss]: choice === 'ai',
                [optionDisabledCss]: isLoading
              })}
            >
              <span className={optionContentCss}>
                <VariantIcon isCallie />
                <span className={optionCopyCss}>
                  <span className={optInOptionLabelCss}>
                    {I18n.t('publisher.growth_experiments.callie_intro_entry_points.ai_label')}
                  </span>
                  <span className={optInOptionDescriptionCss}>
                    {I18n.t('publisher.growth_experiments.callie_intro_entry_points.opt_in.ai_description')}
                  </span>
                </span>
              </span>
              <span className={optInRadioWrapperCss}>
                <RadioInput
                  aria-label={I18n.t('publisher.growth_experiments.callie_intro_entry_points.ai_label')}
                  checked={choice === 'ai'}
                  disabled={isLoading}
                  name="callie-intro-entry-point"
                  onChange={() => setChoice('ai')}
                  value="ai"
                />
                <span
                  aria-hidden
                  className={classNames(optInRadioVisualCss, {
                    [optInRadioVisualSelectedCss]: choice === 'ai'
                  })}
                >
                  {choice === 'ai' && <img alt="" className={optInRadioDotCss} src={radioSelectedDot} />}
                </span>
              </span>
            </label>
            <label
              className={classNames(optionCss, {
                [optionSelectedCss]: choice === 'link',
                [optionDisabledCss]: isLoading
              })}
            >
              <span className={optionContentCss}>
                <VariantIcon isCallie={false} />
                <span className={optionCopyCss}>
                  <span className={optInOptionLabelCss}>
                    {I18n.t('publisher.growth_experiments.callie_intro_entry_points.link_label')}
                  </span>
                  <span className={optInOptionDescriptionCss}>
                    {I18n.t('publisher.growth_experiments.callie_intro_entry_points.link_description')}
                  </span>
                </span>
              </span>
              <span className={optInRadioWrapperCss}>
                <RadioInput
                  aria-label={I18n.t('publisher.growth_experiments.callie_intro_entry_points.link_label')}
                  checked={choice === 'link'}
                  disabled={isLoading}
                  name="callie-intro-entry-point"
                  onChange={() => setChoice('link')}
                  value="link"
                />
                <span
                  aria-hidden
                  className={classNames(optInRadioVisualCss, {
                    [optInRadioVisualSelectedCss]: choice === 'link'
                  })}
                >
                  {choice === 'link' && <img alt="" className={optInRadioDotCss} src={radioSelectedDot} />}
                </span>
              </span>
            </label>
          </div>
        </div>
        <div className={optInFooterCss}>
          <Button
            className={optInButtonCss}
            data-testid="callie-primary-action"
            disabled={isLoading}
            loading={isLoading}
            onClick={() => onSave({ response: choice === 'ai' ? 'opted_in' : 'opted_out' }, choice === 'ai')}
          >
            {I18n.t('publisher.growth_experiments.callie_intro_entry_points.continue')}
          </Button>
        </div>
      </div>
    </Popup>
  )
}
